/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.1
 */


import { createAction } from '../../../../modules/app/createAction';
import {
    LOAD_WIDGET_META,
    LOAD_WIDGET_META_FAILED,
    LOAD_WIDGET_META_SUCCESSFUL,
} from './constants/widgetActionConstants';
import {
    TLoadWidgetMetaAction,
    TLoadWidgetMetaFailedAction,
    TLoadWidgetMetaSuccessfulAction,
    TWidgetMetaList,
} from './widgetTypes';

export const loadWidgetMeta = (): TLoadWidgetMetaAction =>
    createAction(LOAD_WIDGET_META);
export const loadWidgetMetaSuccessful = (payload: TWidgetMetaList): TLoadWidgetMetaSuccessfulAction =>
    createAction(LOAD_WIDGET_META_SUCCESSFUL, payload);
export const loadWidgetMetaFailed = (payload: string): TLoadWidgetMetaFailedAction =>
    createAction(LOAD_WIDGET_META_FAILED, payload);
